import defaults from './content.json';
import type { Constraint, Phase, Point } from './volleyball';

/**
 * Alles, was die Trainerin selbst bearbeiten kann, liegt in `content.json`.
 * Der Bearbeitungsmodus (`?edit=1`) ändert eine Kopie davon im Browser und
 * exportiert sie als neue `content.json`.
 */
export interface Content {
  hero: { eyebrow: string; title1: string; title2: string; intro: string; bubble: string; caption: string };
  /** Kurztexte der drei Kacheln auf der Startseite */
  home: { grundlagen: string; trainer: string; position: string; regeln: string };
  /** Auswahlseite im Kapitel "Meine Position" */
  position: { title: string; intro: string };
  basics: { title1: string; title2: string; intro: string; cta: string; rules: { title: string; text: string }[] };
  trainer: { badge: string; phases: Record<Phase, { label: string; title: string; text: string }> };
  regeln: { intro: string };
  /**
   * Eigene Texte der Trainerin für "Meine Position": Figur → Rotation → Phase.
   * Fehlt ein Eintrag, wird der Text automatisch erzeugt (src/data/personal.ts).
   */
  personal?: Record<string, Record<string, Partial<Record<Phase, string>>>>;
  /** Sprechblasen der Maskottchen je Kapitel */
  buddies: { grundlagen: string; trainer: string; position: string; positionChosen: string; regeln: string; weiter: string };
  /** Annahmeformation je Rotation ("1"…"6") und Figur */
  reception: Record<string, Record<string, Point>>;
  /** Orange Linien je Rotation */
  constraints: Record<string, Constraint[]>;
}

export const DEFAULT_CONTENT = defaults as Content;

/** Unter diesem Schlüssel liegt der Entwurf im Browser */
export const DRAFT_KEY = 'laeufersystem-content-draft';
